module.exports = __webpack_public_path__ + "img/t2.79da671f.png";